import { Link } from 'react-router-dom';

const footerLinks = [
  { name: 'Home', to: '/' },
  { name: 'Blog', to: '/blog/best-sugargoo-spreadsheet-2026-guide' },
  { name: 'Safety Guide', to: '/safety-guide' },
  { name: 'About Us', to: '/about' },
  { name: 'Contact', to: '/contact' },
  { name: 'Disclaimer', to: '/disclaimer' },
];

const socialLinks = [
  { icon: 'ri-twitter-x-line', url: '#' },
  { icon: 'ri-reddit-line', url: '#' },
  { icon: 'ri-discord-line', url: '#' },
  { icon: 'ri-telegram-line', url: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-16">
          <div>
            <h3 className="font-heading text-3xl md:text-4xl font-bold mb-4">
              SUGARGOO SPREADSHEET
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm">
              The most comprehensive directory of Sugargoo spreadsheet finds. We curate and organize the best product links for sneakers, clothing, accessories, and budget-friendly discoveries.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.icon}
                  href={social.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-5">Quick Links</h4>
            <div className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.to}
                  className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-5">Visit Our Main Site</h4>
            <p className="text-sm text-white/60 mb-4">
              For the full shopping experience, visit our main spreadsheet platform.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Go to kaspreadsheet.com
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. This is an independent informational resource.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/disclaimer" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">
              Disclaimer
            </Link>
            <Link to="/contact" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}